import React, { useState, useEffect } from "react";
import "./CustomerDashboard.scss";
import { useTranslation } from "react-i18next";
import { campaignData, productData } from "../../store/action/index";
import { login } from "../../store/action/index";
import { useHistory, useLocation } from "react-router";
import logo from "../../assets/LAETUS.png";
import { useSelector, useDispatch } from "react-redux";
import Modals from "../Modal/Modal";
import { Auth } from "aws-amplify";

const CustomerDashboard = () => {
  const { t } = useTranslation();
  const history = useHistory();
  const location = useLocation();
  const [success, setsuccess] = useState(false);

  const dispatch = useDispatch();
  const logindata = useSelector((state) => state.login);
  const [openmodal, setopenmodal] = useState(false);
  const [modal, setmodal] = useState(false);
  const [icon, setIcon] = useState(false);
  const handleGuide = () => {
    const win = window.open(
      "https://www.laetus-store.com/guide-du-createur",
      "_blank"
    );
    win.focus();
  };
  const handleLeatus = () => {
    const win = window.open("https://www.laetus-store.com/", "_self");
    win.focus();
  };

  async function signOut() {
    try {
      await Auth.signOut();
      setsuccess(true);
      dispatch(
        campaignData({
          campaign: [],
          addtocart: [],
        })
      );
    } catch (error) {
      const data = error;
    }
  }
  useEffect(() => {
    if (success) {
      localStorage.setItem("email", "");
      history.push("/auth");
      dispatch(
        login({
          loginStatus: false,
          userDetail: null,
          webflowid: null,
        })
      );
      dispatch(
        productData({
          step: 0,
          shirt: {},
          designnimg: "",
          color: "",
          price: 0,
          day: 0,
          sales: 0,
          shirtname: "",
          brief: "",
          detail: "",
          campaign: 0,
          shirtdesign: [],
          shirtdesignback: [],
          frontDesignObj: null,
          backDesignObj: null,
          alterImage: null,
        })
      );
    }
  }, [success]);

  return (
    <>
      <div className="customer-dashboard">
        <div className="leftside">
          <div className="image cp">
            <img
              src={logo}
              width={150}
              height={130}
              onClick={() => history.push("/home")}
            />
          </div>
          <div className="option">
            <p
              className="para"
              style={{
                color:
                  (location.pathname === "/home" && "#000") ||
                  (location.pathname === "/order" && "#000"),
              }}
              onClick={() => history.push("/home")}
            >
              {t("home")}
            </p>
            <p
              className="para"
              style={{
                color:
                  (location.pathname === "/campaign" ||
                    location.pathname === "/compaigndraft" ||
                    location.pathname === "compaigndetail") &&
                  "#000",
              }}
              onClick={() => history.push("/campaign")}
            >
              {t("campaign")}
            </p>
            <p
              className="para"
              style={{ color: location.pathname === "/payment" && "#000" }}
              onClick={() => history.push("/payment")}
            >
              {t("payment")}
            </p>
            <p className="para" onClick={() => handleGuide()}>
              {t("Guide")}
            </p>
            <hr />
            <p
              className="para"
              style={{ color: location.pathname === "/samples" && "#000" }}
              onClick={() => history.push("/samples")}
            >
              {t("command")}
            </p>
            <p>{t("purchases")}</p>
            <hr />
            <p
              className="para"
              style={{ color: location.pathname === "/setting" && "#000" }}
              onClick={() => history.push("/setting")}
            >
              {t("setting")}
            </p>
            <p
              className="invite"
              style={{ color: location.pathname === "/referral" && "#000" }}
              onClick={() => history.push("/referral")}
            >
              {t("invite-friend")}
            </p>
            <div className="back">
              {logindata.loginStatus ? (
                <p
                  onClick={() => signOut()}
                  style={{
                    color: "#000",
                    marginLeft: "3px",
                    marginBottom: "4px",
                  }}
                >
                  {t("logout")}
                </p>
              ) : (
                <p
                  onClick={() => {
                    history.push("/auth");
                  }}
                  style={{
                    color: "#000",
                    marginLeft: "3px",
                    marginBottom: "4px",
                  }}
                >
                  {t("login")}
                </p>
              )}
              <p onClick={() => handleLeatus()} style={{ color: "#000" }}>
                {t("back-leatus")}
              </p>
            </div>
          </div>
        </div>
      </div>
      {modal ? (
        <Modals
          condition="login"
          setopenmodal={setopenmodal}
          setIcon={setIcon}
          openmodal={openmodal}
          setmodal={setmodal}
        />
      ) : null}
    </>
  );
};
export default CustomerDashboard;
